<template>
  <el-checkbox
    :ref="'condition-item-' + source.col"
    class="condition-item"
    v-model="checked"
    @change="onCheckChange"
  >
    <span class="col">{{ getsHAI }}</span>
    <span class="col">({{ source.num }}个)</span>
    <!-- <span class="col" v-if="this.source.totalNum"
      >(合计{{ source.totalNum }})</span
    > -->
  </el-checkbox>
</template>

<script>
import Emitter from "@/utils/emitter-mixin";
export default {
  name: "ConditionItem",
  mixins: [Emitter],
  props: {
    source: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  watch: {
    "source.checked": {
      handler(val) {
        this.checked = val;
      },
      immediate: true
    }
  },
  computed: {
    headerFilters() {
      return this.$store.state.user.TypeofFlag;
    }
  },
  data() {
    return {
      checked: false,
      getsHAI: ""
    };
  },
  methods: {
    onCheckChange(checked) {
      this.dispatch(
        "QTableHeaderFilter",
        "checkBoxValueChange",
        this.source.col,
        checked,
        this.source.totalNum
      );
    },
    getScole() {
      // 供需满足跟进表的表头筛选值处理百分比和小数
      let name = this.headerFilters;
      if (this.source.col) {
        let str = this.source.col.toString();
            if(!isNaN(this.source.col)){
                if (
            name == "SALEPRESELLRATIO" ||
            name == "PRESELLSUPPLYRATIO" ||
            name == "ADJUSTPRESELLSUPPLYRATIO" ||
            name == "PRESELLSUPPLYUNAPPROVERATIO" ||
            name == 'ADJUSTPRESELLSUPPLYUNAPPROVERATIO' ||
            name == 'PRESELLINVENTORYRATIO' ||
            name == 'ADJUSTPRESELLINVENTORYRATIO' ||
            name == 'PRESELLMAKINGRATIO' ||
            name == 'ADJUSTPRESELLPLANRATIO' ||
            name == 'PRESELLSTOCKRATIO' ||
            name == 'ADJUSTPRESELLSTOCKRATIO' ||
            name == 'ADJUSTPRESELLMAKINGRATIO' ||
            name == 'PRESELLPLANRATIO' ||
            name == 'SUPPLYUNAPPROVERATIODIFF' || 
            name == 'INVENTORYRATIODIFF' ||
            name == 'SUPPLYRATIODIFF' ||
            name == 'MAKINGRATIODIFF' ||
            name == 'PLANRATIODIFF' ||
            name == 'STOCKRATIODIFF'
          ) {
            this.getsHAI = ((Number(this.source.col)*100).toFixed(2) ) + "%";
          }else{
             if(str.indexOf(".") != -1){
               this.getsHAI = Number(this.source.col).toFixed(2);
             }else{
               this.getsHAI = this.source.col;
             }
          }
            }else{
              this.getsHAI = this.source.col;

            }
      }
    }
  },
  mounted() {
    let routerName =  this.$route.name
    if(routerName == 'asatisfyFollowup' || routerName == 'preSalesheet' ){
    this.getScole();
    }else{
       this.getsHAI = this.source.col;
    }

    
  }
};
</script>

<style lang="stylus" scoped>
.condition-item
    display block

>>> .el-checkbox__label .col
    padding-right 10px
</style>
